import React from 'react';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ConditionsTreated = () => {
  const conditions = [
    {
      category: 'Spine & Joint Pain',
      image: '/images/services/Spine_joint_Pain.jpg',
      items: ['Spondylitis', 'Herniated Discs', 'Stenosis', 'Arthritis', 'Sciatica', 'Lower Back Pain']
    },
    {
      category: 'Neurological Disorders',
      image: '/images/services/Neurological_Disorders.jpg',
      items: ['Stroke Recovery', 'Paralysis', 'Parkinsonism', 'Migraines', 'Trigeminal Neuralgia', 'Bell\'s Palsy']
    },
    {
      category: 'Sports & Musculoskeletal',
      image: '/images/services/Sports_Musculoskeletal.jpg',
      items: ['Sports Injuries', 'Frozen Shoulder', 'AVN', 'Ligament Sprains', 'Tennis Elbow', 'Muscle Strains']
    },
    {
      category: 'Chronic Pain',
      image: '/images/services/Chronic_Pain.jpg',
      items: ['Tingling & Numbness', 'Knee/Elbow Pain', 'Ankle Pain', 'Fibromyalgia', 'Myofascial Pain', 'Chronic Fatigue']
    },
    {
      category: 'Postural Disorders',
      image: '/images/services/Postural_Disorders.jpg',
      items: ['Scoliosis', 'Kyphosis', 'Text Neck', 'Rounded Shoulders', 'Forward Head Posture', 'Lordosis']
    },
    {
      category: 'Advanced Spine Care',
      image: '/images/services/Advanced_Spine_Care.jpg',
      items: ['Cervical Issues', 'Lumbar Decompression', 'Nerve Impingement', 'Disc Bulge', 'Facet Syndrome', 'Pelvic Tilt']
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
            Conditions We <span className="text-emerald-600">Treat Successfully</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our unique blend of Jiva Nadi and modern chiropractic science offers a deeply personalized path to recovery for various chronic and acute conditions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {conditions.map((condition, index) => (
            <div key={index} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 border border-gray-200 hover:border-emerald-300">
              <div className="relative h-60 overflow-hidden bg-gray-100">
                <img 
                  src={condition.image} 
                  alt={condition.category}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-5">
                  {condition.category}
                </h3>
                <div className="grid grid-cols-1 gap-3">
                  {condition.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center space-x-3">
                      <div className="flex-shrink-0 w-5 h-5 bg-emerald-100 rounded-full flex items-center justify-center group-hover:bg-emerald-600 transition-colors">
                        <SafeIcon icon={FiCheck} className="w-3 h-3 text-emerald-600 group-hover:text-white transition-colors" />
                      </div>
                      <span className="text-gray-700 font-medium text-sm leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-emerald-900 rounded-[2rem] p-8 lg:p-12 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-800/30 rounded-full -mr-32 -mt-32 blur-3xl"></div>
          <div className="relative z-10">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4">Are you suffering from one of these?</h3>
            <p className="text-emerald-100 mb-8 max-w-2xl mx-auto">
              Don't wait for the pain to become permanent. Dr. Saurabh Singh specializes in safe and effective adjustments that deliver results when others fall short.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button className="bg-white text-emerald-900 px-8 py-3 rounded-full font-bold hover:bg-emerald-50 transition-colors shadow-lg">
                Get Free Diagnosis
              </button>
              <a href="tel:+919581556660" className="bg-emerald-700 text-white border border-emerald-500 px-8 py-3 rounded-full font-bold hover:bg-emerald-600 transition-colors">
                Call Expert Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConditionsTreated;